exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#side-menu {\n  position: fixed;\n  display: block;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100%;\n  min-width: 320px;\n  overflow: hidden;\n  z-index: 1000;\n}\n#side-menu .side-menu-header {\n  width: 100%;\n}\n.side-menu-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 100%;\n  z-index: 990;\n}", ""]);

// exports
